import { useTheme } from "@/context/ThemeContext";
import { useLanguage } from "@/context/LanguageContext";

export function ThemeToggle() {
  const { toggle, accent } = useTheme();
  const { t } = useLanguage();
  const label = t.colors?.[accent] || accent;
  return (
    <button
      data-testid="theme-toggle"
      onClick={toggle}
      aria-label="Cycle heritage accent colour: gold, green, blue"
      title="Accent: Gold / Green / Blue"
      className="flex items-center gap-2 rounded-md border border-clan-ink/15 bg-clan-ink/[0.04] px-2.5 py-1.5 font-mono text-[10px] uppercase tracking-widest text-clan-ink backdrop-blur-md transition-colors duration-300 hover:border-clan-accent/60 hover:bg-clan-ink/[0.07] focus:outline-none focus:ring-2 focus:ring-clan-accent sm:px-3 sm:py-2"
    >
      <span className="h-3.5 w-3.5 rounded-md border border-clan-ink/25" style={{ background: "hsl(var(--accent-hsl))" }} />
      <span className="hidden sm:inline">{label}</span>
    </button>
  );
}
